import Script from "next/script";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export default function Matomo() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        if (typeof window !== "undefined" && (window as any)._mtm) {
            (window as any)._mtm.push({'event': 'mtm.PageView'});
        }
    }, [pathname, searchParams]);

    return (
        <Script id="matomo-script" strategy="beforeInteractive">
            {`
                var _mtm = window._mtm = window._mtm || [];
                _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
                (function() {
                    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                    g.async=true; g.src='https://matomo.traqq.com/js/container_7StK3Bu7.js';
                    s.parentNode.insertBefore(g,s);
                })();
            `}
        </Script>
    );
}
